import { localURL } from "./localURLBuilder";
import HTTP_Launcher from "./http_launcher";
import { getLocalHostProxy } from "./configResolver";

const ta_launcher = new HTTP_Launcher(localURL, getLocalHostProxy());
export default ta_launcher;
